<template>
  <div class="container-fluid current-sale-line"
       :class="{
         'new-item': isNewItem,
         'updated-item': isUpdatedItem
       }"
       style="margin: 0; padding: 0;">
    <template>
      <div class="container-fluid current-sale-line" style="margin: 0; padding: 0;">
        <div class="row" @click="$emit('click')">
          <div class="line-description-pane col-7">
            <h6 class="line-description">
              {{ $utils.toPascalCase($utils.cutLength(saleLine.Description.slice(0, 30) + '...', 60)) }}<br>
            </h6>
            <h5 class="text-success text-sm " v-if="saleLine.Discount>0">
              {{ `Discount ${$utils.formatMoney(saleLine.Discount)}` }}</h5>

            <h5 class="text-info text-sm " v-if="saleLine.tourismLevy && saleLine.tourismLevy >0">
              {{ `T.L ${$utils.formatMoney(saleLine.tourismLevy * saleLine.Qty)}` }}</h5>
          </div>
          <div class="d-flex flex-column justify-content-between line-prices-pane col-5">
            <div class="price-row">
              <p class="price-label qty">{{ saleLine.Qty }}<span class="line-price"></span></p>
              <p class="price-label unit">{{ $utils.formatMoney(saleLine.Unit, 2, '.', ',', false) }}<span
                  class="line-price"></span></p>
              <p class="price-label total">{{
                  $utils.formatMoney(((saleLine.Unit + saleLine.tourismLevy) * saleLine.Qty) - saleLine.Discount + instructionTotal, 2, '.', ',', false)
                }}<span class="line-price"></span></p>
            </div>
          </div>
        </div>
        <div class="row">
          <ul class="cooking-instruction-list" v-if="hasInstructions">
            <li class="cooking-instruction-list-item" v-for="instruction in instructions">
              {{ instruction.CookingMsg }} <span>{{ instruction.count }} X {{
                $utils.formatMoney(instruction.Price)
              }}</span>
              Total: {{ $utils.formatMoney(instruction.count * instruction.Price) }}
            </li>
          </ul>
        </div>
      </div>
    </template>
  </div>
</template>


<script>
import CurrentSaleQty from "@/components/point-of-sale/sales/CurrentSaleQty";
import LineSeparator from "@/components/layout/utils/LineSeparator";

export default {
  name: "CurrentSaleLine",
  components: {LineSeparator, CurrentSaleQty},
  data() {
    return {
      discountType: 'value',
      discountAmount: 0.00,
      uuid: generateUUID(),
    }
  },
  props: {
    saleLine: {
      type: Object,
      required: true
    },
    isNewItem: {
      type: Boolean,
      default: false
    },
    isUpdatedItem: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasInstructions() {
      return (this.saleLine.instructions && this.saleLine.instructions.length > 0)
    },
    instructionTotal() {
      if (!this.saleLine.instructions || this.saleLine.instructions.length === 0) return 0.00;
      let total = this.saleLine.instructions.map(i => i.Price * i.count).reduce((acc, n) => Number(n) + Number(acc))
      if (isNaN(total)) {
        return 0.00;
      }
      return Number(total.toFixed(2))
    },
    instructions() {
      return this.saleLine.instructions.map((int) => {
        int.Price = Number(int.Price.toFixed(2))
        return int;
      });
    }
  },
  methods: {
    voidItem(item) {
      this.$store.commit(`setOverrideDetails`, `Void Line (${item.Description})`)
      this.$store.commit('voidLine', item)
    },
    async discount() {
      let isAllowed = await this.$store.dispatch(`validateSecurityPermission`, `Discount`)
      if (!isAllowed) return;
      this.$emit('open-discount-modal', {
        saleLine: this.saleLine,
        uuid: this.uuid
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.current-sale-line {

  .row {
    .line-description-pane {
      .line-description {
        font-size: 14px;
        margin: 0;
        line-height: 18px;
        font-weight: 500;
        color: var(--text-primary);
      }
    }

    .line-prices-pane {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .price-label {
        font-size: 12px;
        margin: 0;
        color: var(--text-primary);

        .line-price {
          font-size: 15px;
          font-weight: 700;
          color: var(--text-primary);
        }
      }
    }
  }

  &.new-item {
    background-color: rgba(var(--success-rgb), 0.1);
    border-left: 4px solid var(--success);
    transition: background-color 0.3s ease;
  }

  &.updated-item {
    background-color: rgba(var(--warning-rgb), 0.1);
    border-left: 4px solid var(--warning);
    transition: background-color 0.3s ease;
  }
}

button {
  background-color: transparent;
}

.cooking-instruction-list {
  list-style: inside;

  .cooking-instruction-list-item {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    color: var(--text-secondary);
    display: flex;
    justify-content: space-between;
  }
}

.price-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr; /* Create 3 columns */
  gap: 10px; /* Add some space between the columns */
  align-items: center; /* Vertically align content */
}

.text-sm {
  font-size: 12px;
}

#discount-btn {
  padding: 2px;
  border-radius: 5px;
}
</style>
